/* eslint-disable */
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

//import url and gateway methods
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const MedicalConsentDetails = ({
  selectedConsentId = null,
  setSelectedConsentId = () => {},
  afterActionClose = () => {},
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");

  const [consentData, setConsentData] = useState({
    recipient: {},
    authorizedDataCategories: [],
    duration: {},
    purpose: "",
    additionalinformation: "",
    isactive: true,
  });

  const [isRevoking, setIsRevoking] = useState(false);

  // Get consent details and map API data
  const getConsentDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MEDICAL_CONSENT_DETAILS +
        `/${selectedConsentId}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      if (response.status && response.data) {
        const apiData = response.data;
        setConsentData({
          recipient: {
            name: `${apiData.authorizeduserid?.name || ""} ${
              apiData.authorizeduserid?.surname || ""
            }`,
            role: "Doctor",
            email: apiData.authorizeduserid?.email || "",
          },
          authorizedDataCategories: apiData.medicalrecords || [],
          duration: {
            ispermanent: apiData.ispermanent,
            createdDate: apiData.createdAt,
            approvedDate: apiData.approvaldate,
            revocationdate: apiData.revocationdate,
          },
          purpose: apiData.purpose || "",
          additionalinformation: apiData.additionalinformation || "",
          isactive: apiData.isactive,
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for revoke consent
  const revokeConsentHandler = async () => {
    try {
      const apiData = {
        revocationdate: Date.now(),
        isactive: false,
      };

      const requestUrl =
        url.API_BASE_URL +
        url.API_UPDATE_MEDICAL_CONSENT +
        `/${selectedConsentId}` +
        `?token=${token}`;

      const response = await putData(requestUrl, apiData);

      if (response.status) {
        //close offcanvas
        let offCanvasPopup = document.querySelector(
          "#medicalConsentDetailsOffCanvas"
        );
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        resetHandler();
        afterActionClose([response.data]);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsRevoking(false);
    }
  };

  // Reset handler
  const resetHandler = () => {
    setConsentData({
      recipient: {},
      authorizedDataCategories: [],
      duration: {},
      purpose: "",
      additionalinformation: "",
      isactive: true,
    });
    setSelectedConsentId(null);
  };

  useEffect(() => {
    if (selectedConsentId) {
      getConsentDetails();
    }
  }, [selectedConsentId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="medicalConsentDetailsOffCanvas"
      aria-labelledby="medicalConsentDetailsOffCanvas"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              assignment
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              Medical Consent Details
            </h3>
            <p className="text-white fs-sm mb-0">
              View medical consent information
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        {consentData.isactive ? (
          <div
            className="alert alert-success border-success shadow-sm d-flex align-items-center gap-2"
            role="alert"
            style={{ borderRadius: "8px" }}
          >
            <span className="material-symbols-outlined text-success">
              check_circle
            </span>
            This consent is currently active and valid
          </div>
        ) : (
          <div
            className="alert alert-danger border-danger shadow-sm d-flex align-items-center gap-2"
            role="alert"
            style={{ borderRadius: "8px" }}
          >
            <span className="material-symbols-outlined text-danger">block</span>
            The consent is revoked.
          </div>
        )}

        <div
          className="question-card bg-white border-0 rounded-4 shadow-lg mb-4 overflow-hidden"
          style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          }}
        >
          <div
            className="question-header bg-gradient-light border-bottom border-gray-300 p-3 p-lg-4"
            style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f1f3f4 100%)",
            }}
          >
            <h5 className="mb-0 d-flex align-items-center text-primary fw-bold">
              <span className="material-symbols-outlined me-2">person</span>
              Recipient Information
            </h5>
          </div>
          <div className="question-content p-3 p-lg-4">
            <div className="row">
              <div className="col-md-4">
                <div className="detail-item">
                  <label className="d-block fw-semibold mb-2 text-muted">
                    <span className="material-symbols-outlined me-1 fs-6">
                      badge
                    </span>
                    Name
                  </label>
                  <p className="mb-0 fw-medium">{consentData.recipient.name}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="detail-item">
                  <label className="d-block fw-semibold mb-2 text-muted">
                    <span className="material-symbols-outlined me-1 fs-6">
                      work
                    </span>
                    Role
                  </label>
                  <p className="mb-0 fw-medium">{consentData.recipient.role}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="detail-item">
                  <label className="d-block fw-semibold mb-2 text-muted">
                    <span className="material-symbols-outlined me-1 fs-6">
                      email
                    </span>
                    Email
                  </label>
                  <p className="mb-0 fw-medium">
                    {consentData.recipient.email}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="question-card bg-white border-0 rounded-4 shadow-lg mb-4 overflow-hidden"
          style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          }}
        >
          <div
            className="question-header bg-gradient-light border-bottom border-gray-300 p-3 p-lg-4"
            style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f1f3f4 100%)",
            }}
          >
            <h5 className="mb-0 d-flex align-items-center text-primary fw-bold">
              <span className="material-symbols-outlined me-2">folder</span>
              Authorized Records
            </h5>
          </div>
          <div className="question-content p-3 p-lg-4">
            <div className="d-flex flex-wrap gap-2">
              {consentData?.authorizedDataCategories?.map((record, index) => (
                <div key={index}>
                  <div
                    className="border-0 rounded-3 p-3 bg-danger-subtle shadow-sm h-100"
                    style={{
                      transition: "transform 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.02)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <h6 className="fw-semibold text-primary mb-0">
                      {record.recordname}
                    </h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className="question-card bg-white border-0 rounded-4 shadow-lg mb-4 overflow-hidden"
          style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          }}
        >
          <div
            className="question-header bg-gradient-light border-bottom border-gray-300 p-3 p-lg-4"
            style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f1f3f4 100%)",
            }}
          >
            <h5 className="mb-0 d-flex align-items-center text-primary fw-bold">
              <span className="material-symbols-outlined me-2">schedule</span>
              Duration & Important Dates
            </h5>
          </div>
          <div className="question-content p-3 p-lg-4">
            <div className="row">
              <div className="col-md-3">
                <div className="detail-item">
                  <label className="d-block fw-semibold mb-2 text-muted">
                    <span className="material-symbols-outlined me-1 fs-6">
                      timer
                    </span>
                    Duration Type
                  </label>
                  <p className="mb-0 fw-medium">
                    {consentData.duration.ispermanent
                      ? "Permanent"
                      : "Temporary"}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="detail-item">
                  <label className="d-block fw-semibold mb-2 text-muted">
                    <span className="material-symbols-outlined me-1 fs-6">
                      calendar_today
                    </span>
                    Created Date
                  </label>
                  <p className="mb-0 fw-medium">
                    {consentData.duration.createdDate
                      ? new Date(
                          consentData.duration.createdDate
                        ).toLocaleDateString()
                      : ""}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="detail-item">
                  <label className="d-block fw-semibold mb-2 text-muted">
                    <span className="material-symbols-outlined me-1 fs-6">
                      event_available
                    </span>
                    Approved Date
                  </label>
                  <p className="mb-0 fw-medium">
                    {consentData.duration.approvedDate
                      ? new Date(
                          consentData.duration.approvedDate
                        ).toLocaleDateString()
                      : ""}
                  </p>
                </div>
              </div>
              {!consentData.isactive && consentData.duration.revocationdate && (
                <div className="col-md-3">
                  <div className="detail-item">
                    <label className="d-block fw-semibold mb-2 text-muted">
                      <span className="material-symbols-outlined me-1 fs-6">
                        cancel
                      </span>
                      Revocation Date
                    </label>
                    <p className="mb-0 fw-medium">
                      {new Date(
                        consentData.duration.revocationdate
                      ).toLocaleDateString()}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="question-card bg-white border-0 rounded-4 shadow-lg mb-4 overflow-hidden"
          style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          }}
        >
          <div
            className="question-header bg-gradient-light border-bottom border-gray-300 p-3 p-lg-4"
            style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f1f3f4 100%)",
            }}
          >
            <h5 className="mb-0 d-flex align-items-center text-primary fw-bold">
              <span className="material-symbols-outlined me-2">info</span>
              Purpose & Additional Information
            </h5>
          </div>
          <div className="question-content p-3 p-lg-4">
            <p className="mb-0 fw-medium">Purpose : {consentData.purpose}</p>
            <p className="mb-0 fw-medium">
              Additional Information : {consentData.additionalinformation}
            </p>
          </div>
        </div>

        <div
          className={
            consentData.isactive ? "mb-3 d-flex justify-content-end" : "d-none"
          }
        >
          <button
            className="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2 px-4 py-2 shadow-sm"
            onClick={revokeConsentHandler}
            disabled={isRevoking ? true : false}
            style={{
              cursor: isRevoking ? "not-allowed" : "pointer",
            }}
          >
            {isRevoking ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                {t("Revoking...")}
              </>
            ) : (
              <>
                <span className="material-symbols-outlined icon-sm">block</span>
                <span className="fw-semibold">{t("Revoke this consent")}</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MedicalConsentDetails;
